interface IconProps { className?: string; size?: number }

export function PlusIcon({ className = '', size = 20 }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
      viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"
      className={className} aria-hidden="true">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  )
}

export function ArrowIcon({ className = '', size = 20 }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
      viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"
      className={className} aria-hidden="true">
      <line x1="5" y1="12" x2="18" y2="12" />
      <polyline points="13 7, 18 12, 13 17" />
    </svg>
  )
}
